/**
 * `/o/:calendarId/:ownerToken` — the key link. Stash the token and replace the
 * URL immediately, so the capability stops riding in the address bar (and in
 * history, and in anything that reads it).
 */
import { ownerTokens } from '../owner-tokens';
import type { PageContext, Teardown } from '../router';
import { loadingState } from '../../ui/states';

export function renderOwnerLinkPage(ctx: PageContext): Teardown {
  const calendarId = ctx.params.calendarId!;
  const token = ctx.params.ownerToken!;
  ownerTokens.set(calendarId, token);
  ctx.host.appendChild(loadingState('Opening your calendar'));
  ctx.navigate(`/circles/${calendarId}`, { replace: true });
}
